import React, { useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddUserLayer from "../components/AddUserLayer";
import { Icon } from "@iconify/react/dist/iconify.js";
import Select from 'react-select'
import { API_URL } from "..";
const AddUser = () => {
  const [imagePreviewUrl, setImagePreviewUrl] = useState("");
  const [showAlertMessage, setshowAlertMessage] = useState({
    status:false,
    message:'',
    desc:''
  });
  const [selectedOptions, setSelectedOptions] = useState({});
  const handleChange = (selected) => {
    setSelectedOptions(selected);
  };
  const [jobsData , setJobData] = useState([])
  const fetchJobs = async ()=>{
    let headersList = {
        "Accept": "*/*",
        "Content-Type": "application/json"
       }
       let response = await fetch(API_URL+"/api/affiliates/fetch-affiliates", { 
         method: "GET",
         headers: headersList
       });
       let data = await response.json();
       const formattedData = data.map((e) => ({
        value: e.id,
        label: e.business_name
      }));
      setJobData(formattedData)
}
React.useEffect(()=>{
  fetchJobs()
},[1])

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
    
  };
  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
  const onFormSubmit = async (event) =>{
    event.preventDefault();
    if(isValidEmail(event.target.elements.email_address.value) === false){
      setshowAlertMessage({
        message: 'error',
        status:true,
        desc:'Email address is invalid'
      });
      return false;
    }else{

      let headersList = {
          "Accept": "*/*",
          "Content-Type": "application/json"
         }
         
         let bodyContent = JSON.stringify({
           "name": event.target.elements.fullname.value,
           "email": event.target.elements.email_address.value,
           "password":event.target.elements.password.value,
           "role" : event.target.elements.role.value,
         });
         
         let response = await fetch(API_URL+"/api/user/create", { 
           method: "POST",
           body: bodyContent,
           headers: headersList
         });
         
      //    let data = await response.text();
       
       let data = await response.json();
       if(response.status == 201){
        setshowAlertMessage({
          message: 'success',
          status:true,
          desc:'User Is added successfully'
        });
        event.target.elements.fullname.value='';
        event.target.elements.email_address.value='';
        event.target.elements.password.value='';
       }else{
  
  
        setshowAlertMessage({
          message: 'error',
          status:true,
          desc:'Error while adding new user'
        });
       }
    }
     
  }
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Add User" />

        {/* AddUserLayer */}
        <div className="card h-100 p-0 radius-12">
          <div className="card-body p-24">
            <div className="row justify-content-center">
              <div className="col-xxl-6 col-xl-8 col-lg-10">
                <div className="card border">
                  <div className="card-body">
                   
                    {/* Upload Image Start */}

                    {/* Upload Image End */}
                    <form onSubmit={(event)=>onFormSubmit(event)}>
                    

                      <div className="mb-20">
                        <label
                          htmlFor="name"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Full Name <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="text"
                          name="fullname"
                          className="form-control radius-8"
                          id="name"
                          
                          placeholder="Enter Full Name"
                        />
                      </div>
                      <div className="mb-20">
                        <label
                          htmlFor="email"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Email
                        </label>
                        <input
                          type="email"
                          name="email_address"
                          className="form-control radius-8"
                          id="email"
                          placeholder="Enter email address"
                        />
                      </div>
                      <div className="mb-20">
                        <label
                          htmlFor="password"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Password
                        </label>
                        <input
                          type="password"
                          name="password"
                          className="form-control radius-8"
                          id="email"
                          
                          placeholder="******"
                        />
                      </div>
                      <div className="mb-20">
                        <label
                          htmlFor="password"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Select Role
                        </label>
                         <select name="role" className="form-control">
                          <option value={'admin'}>Admin</option>
                          <option value={'user'}>User</option>
                         </select>
                      </div>
                    
                      {
                      showAlertMessage.status === true?
                    <div
                        className={
                          showAlertMessage.message == 'error' ?
                          "alert alert-danger bg-danger-50 text-danger-600 border-danger-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10":
                          "alert alert-success bg-success-50 text-success-600 border-success-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10"
                        }
                        role="alert"
                    >
                        {showAlertMessage.desc}
                        <button type="button" onClick={()=>setshowAlertMessage(!showAlertMessage)} className="remove-button text-secondary-600 text-xxl line-height-1">
                            {" "}
                            <Icon icon="iconamoon:sign-times-light" className="icon" />
                        </button>
                    </div>:null
                    }
                   
                      <div className="d-flex align-items-center justify-content-center gap-3">
                   
                        <button
                          type="submit"
                          className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                        >
                          Save
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MasterLayout>
    </>
  );
};

export default AddUser;
